import React from "react";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container h-100">
        <div className="row h-100">
          <div className="col-12 d-flex justify-content-center align-items-center">
            <p className="mb-0 text-muted text-center">
              &copy; {new Date().getFullYear()} Allied Electricals Industries Pvt.Ltd. All Rights Reserved
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
